import React from 'react'
import type { MouseEventHandler } from 'react'
import type { NarrativeOcgValidationAction } from '../../types'
import BaseButton from '@/components/common/BaseButton'
import { SpinnerLoader } from '@/components/common/SpinnerLoader'
import KMK_LOADING from '@public/assets/common/kmk_loading.gif'

interface Prop {
  action: NarrativeOcgValidationAction
  icon: string
  label: string
  isActionBusy: boolean
  actionLoading?: NarrativeOcgValidationAction | null
  onClick?: MouseEventHandler<HTMLButtonElement>
}

function MobileIconAction({
  action,
  icon,
  label,
  isActionBusy,
  actionLoading,
  onClick,
}: Prop) {
  return (
    <BaseButton
      className="narrative-ocg-mobile-icon-action inline-flex size-5 !min-h-0 items-center justify-center overflow-hidden rounded !bg-transparent !p-0 shadow-none"
      disabled={isActionBusy}
      fillMode="flat"
      onClick={onClick}
      themeColor="base"
      title={label}
      type="button"
      aria-label={label}
    >
      {actionLoading === action ? (
        // Rewrite / accept run OCG: KMK validating animation; others spin.
        action === 'rewrite' || action === 'accept' ? (
          <img
            alt=""
            src={KMK_LOADING}
            width={20}
            height={20}
            className="block object-contain"
          />
        ) : (
          <SpinnerLoader label="" size={20} />
        )
      ) : (
        <img alt="" className="block size-4" src={icon} />
      )}
    </BaseButton>
  )
}

export default MobileIconAction
